import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {GeoService} from '../services/geographic_service';

export interface State {
  stateName?: string;
  stateCode?: string;
}
@Component({
  selector: 'notd-state-selector',
  templateUrl: './state-selector.component.html',
  styleUrls: ['./state-selector.component.scss']
})
export class StateSelectorComponent implements OnChanges, OnDestroy {
  @Input() defaultStateName: string;
  @Input() defaultCountryCode: string;
  @Input() required: boolean;
  @Output() stateEmitter: EventEmitter<State> = new EventEmitter();

  stateList;
  selectedItem;
  stateSubs;

  constructor(
    private geoService: GeoService) { }

  selectItem(k) {

    if (k === '') {
      k = null;
    }

    this.selectedItem = k;

    if (k) {

      this.stateEmitter.emit({stateCode: k, stateName: this.stateList[k]});

    } else {

      this.stateEmitter.emit();

    }

  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.required === undefined) {
      this.required = false;
    }

    if (!changes.defaultCountryCode) {

      return;
    }

    if (this.stateSubs) {
      this.stateSubs.unsubscribe();
    }

    this.stateSubs = this.geoService.getStates(this.defaultCountryCode).subscribe(
      states => {

        this.stateList = states;

        if (this.defaultStateName) {

          for (const key in this.stateList) {

            if (this.stateList[key] === this.defaultStateName) {

              this.selectedItem = key;

              break;

            }
          }
        }
      },

      err => {

        this.stateList = [];

        console.error('Error', err);

      });

  }

  ngOnDestroy() {
    if (this.stateSubs) {
      this.stateSubs.unsubscribe();
    }
  }
}
